import { render, staticRenderFns } from "./ModalOK.vue?vue&type=template&id=35904ee9&scoped=true&"
import script from "./ModalOK.vue?vue&type=script&lang=js&"
export * from "./ModalOK.vue?vue&type=script&lang=js&"
import style0 from "./ModalOK.vue?vue&type=style&index=0&id=35904ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35904ee9",
  null
  
)

export default component.exports